import { Typography, Card, List } from 'antd';
import styled from 'styled-components';
import { BodyShort01, Caption01 } from 'components/styles';

export const Title = styled(Typography.Text)`
  ${BodyShort01};
  color: var(--gray-100);
`;

export const AttachmentDetails = styled(Typography.Text)`
  ${Caption01};
  color: var(--gray-80);
`;

export const Attachment = styled(List.Item)`
  border-bottom: 0px;
  .ant-list-item-meta {
    align-items: center;
  }
  .ant-list-item-meta-title {
    margin-bottom: 0px;
  }
`;

export const AttachmentCard = styled(Card)`
  box-shadow: none;
  &&& .ant-card-cover {
    display: flex;
    justify-content: center;
    align-items: center;
    height: var(--spacing-11);

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      overflow: hidden;
    }
  }

  &&&:hover {
    .ant-card-actions {
      opacity: 1;
    }
  }

  &&& .ant-card-actions {
    opacity: 0;
    background: #ffffff;
    box-shadow: var(--shadow-08);
    border-radius: 2px;
    border: none;
    position: absolute;
    bottom: 32px;
    right: 10px;

    li {
      margin: 0;
    }
  }
`;

export const AttachmentListContainer = styled.div`
  height: 380px;
  overflow-y: auto;
`;

export const EmptyWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;
